declare var DEBUG:boolean;

/**
 * @ngdoc overview
 * @name sharebase.tracking
 * @module tracking
 * @description
 *
 * # tracking (module)
 * The module enables analytic tracking
 *
 */
import { TrackingService } from './trackingService';
import SettingsService from 'phoenix/services/settingsService';

export * from './trackingService'

let InjectTagManager = (tagManagerId:string) => {
	let scriptUrl = `//www.googletagmanager.com/gtm.js?id=${tagManagerId}`;
	let scriptTag:HTMLScriptElement;
	let firstTag:HTMLScriptElement;
	
	//dataLayer is initialized in the tracking service itself
	scriptTag = document.createElement('script');
	firstTag = document.getElementsByTagName('script')[0];
	scriptTag.async = true;
	scriptTag.src = scriptUrl;
	firstTag.parentNode.insertBefore(scriptTag, firstTag);
};

let InjectExperiments = () => {
	let scriptUrl = '//www.google-analytics.com/analytics.js';
	let alias = 'ga';
	let scriptTag:HTMLScriptElement;
	let firstTag:HTMLScriptElement;
	window['GoogleAnalyticsObject'] = alias;
	window[alias] = window[alias] || function() {
		(window[alias].q = window[alias].q || []).push(arguments)
	};
	window[alias].l = 1 * (new Date() as any);
	scriptTag = document.createElement('script');
	firstTag = document.getElementsByTagName('script')[0];
	scriptTag.async = true;
	scriptTag.src = scriptUrl;
	firstTag.parentNode.insertBefore(scriptTag, firstTag);
};

let TrackingRun = [
	'$rootScope',
	'$window',
	'$location',
	'$timeout',
	'sbTrackingService',
	'settingsService',
	function(
		$rootScope:ng.IRootScopeService,
		$window:ng.IWindowService,
		$location:ng.ILocationService,
		$timeout:ng.ITimeoutService,
		sbTrackingService:TrackingService,
		settingsService:SettingsService
	) {
		// Add the Google Tag Manager script, and then insert Google Optimize (for experiments)
		// above that.  Google recommends adding the optimize script manually as we do here instead
		// of injecting via Tag Manager for performance reasons
		InjectTagManager(settingsService.googleIds.tagManager);
		InjectExperiments();

		//For spec tests, it may not be available
		if (!$window.ga) {
			return;
		}
		
		//init analytics and optimize (A/B testing)
		$window.ga('create', settingsService.googleIds.analytics, 'auto');
		$window.ga('require', settingsService.googleIds.optimize);

		$rootScope.$on('$stateChangeSuccess', event => {
			// clean up urls
			let baseURL = ($location as any).$$absUrl.indexOf('/admin/') > -1 ? '/admin' : '';
			
			//replace share link hash
			let sanitizedPath = $location.path().replace(/\/share\/.*/, '/share-link');
			
			// remove any item ids from url
			// https://regex101.com/r/aMrDl2/3
			sanitizedPath = sanitizedPath.replace(/\/[0-9]+/g, '');

			//send all additional page views
			sbTrackingService.trackPageView(baseURL + sanitizedPath);
		});

		//Watch for angular digest process and fire an 'optimize.activate' event,
		//which will check to see if an experiment variation should be shown or not
		//https://support.google.com/360suite/optimize/answer/7008840?hl=en
		$rootScope.$watch(() => {
			$timeout(() => sbTrackingService.fireExperimentActivationCheck(), 0, false);
		});
}];

export const trackingModule = angular
	.module('sharebase.tracking', [
		'util.storage',
		'site.settings'
	])
	.run(TrackingRun)
	.service('sbTrackingService', TrackingService);


// WEBPACK FOOTER //
// ./src/sharebase/services/trackingService/index.ts